module.exports = __webpack_public_path__ + "img/97-1.3032d030.png";